import React, { Component } from 'react';
import '../styles/Contact.css'
import GoogleMapReact from 'google-map-react';
import ContactMarker from '../images/Footer/marker-small.png'
import MapMarkerBig from '../images/Footer/marker-big.png'
import MapMarker from './MapMarker'
import { injectIntl, defineMessages } from "react-intl"

const messages = defineMessages({
  tel: {
    id: 'contact.tel',
    defaultMessage: 'Tél'
  },
  openCharonne: {
    id: 'contact.openCharonne',
    defaultMessage: 'Ouvert 7 jours sur 7 de 10h à minuit.'
  },
  openVoltaire: {
    id: 'contact.openVoltaire',
    defaultMessage: 'Ouvert 7 jours sur 7 de 10h à minuit.'
  }
})

const coordinates = {
  charonne: {
    lat: 48.85592,
    lng: 2.388316
  },
  stMaur: {
    lat: 48.860365,
    lng: 2.383368
  }
}

class Contact extends Component {
  static defaultProps = {
    center: {
      lat: (coordinates.charonne.lat + coordinates.stMaur.lat) / 2,
      lng: (coordinates.charonne.lng + coordinates.stMaur.lng) / 2
    },
    zoom: 14
  };

  constructor(props) {
    super(props)
    this.state = {
      showMap: (window.mapLoaded ? true : false)
    }

    const self = this;
    window.addEventListener("load", function() {
      setTimeout(() => {
        self.setState({showMap: true});
        window.mapLoaded = true;
      }, 2000);
    });
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="contact">
        <div className="contact-text">
          <div className="contact-text-block contact-text-block--left">
            <h4>
              <div style={{ backgroundImage: `url(${ContactMarker})`}} className="contact-marker">1</div>
              One Hour – Charonne
            </h4>
			<h3>
			  Lost Asylum / Very Bad Night
			</h3>
            <p>24 RUE EMILE LEPEU <br />
            <span className="contact-capitalize">75011 Paris</span>
            </p>
            <p><a href="https://www.one-hour.fr/contact/">Nous contacter
               </a>
            </p>
            <p>
              {formatMessage(messages.openCharonne)}
            </p>
          </div>
          <div className="contact-text-block">
            <h4>
              <div style={{ backgroundImage: `url(${ContactMarker})`}} className="contact-marker">2</div>
              One Hour – Voltaire
            </h4>
			<h3>
			  L'abattoir / Yakuza / Expédition Maudite
			</h3>
            <p>23 RUE SERVAN <br />
            <span className="contact-capitalize">75011 Paris</span>
            </p>
            <p><a href="https://www.one-hour.fr/contact/">Nous contacter
               </a>
            </p>
            <p>
              {formatMessage(messages.openVoltaire)}
            </p>
          </div>
        </div>
        <div className="contact-map">
        {this.state.showMap ? 
          <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyCg0zC4AehnpSR4_oJdQRgEfkqyeUFe80Q" }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
          >
          <MapMarker
            icon={MapMarkerBig}
            position={1}
            lat={coordinates.charonne.lat}
            lng={coordinates.charonne.lng}/>
          <MapMarker
            icon={MapMarkerBig}
            position={2}
            lat={coordinates.stMaur.lat}
            lng={coordinates.stMaur.lng}/>
          </GoogleMapReact> : '' }
        </div>
      </div>
    );
  }
}

export default injectIntl(Contact)



// WEBPACK FOOTER //
// ./src/components/Contact.js